import { graphql, useLazyLoadQuery } from "react-relay"
import type { useIsTelematikInfrastructureSigningEnabledQuery } from "@/modules/patients/detail/conclude/services/de/__generated__/useIsTelematikInfrastructureSigningEnabledQuery.graphql"

const isTelematikInfrastructureSigningEnabledQuery = graphql`
  query useIsTelematikInfrastructureSigningEnabledQuery {
    de_isTelematikInfrastructureSigningEnabled
  }
`

const useIsTelematikInfrastructureSigningEnabled = () => {
  const result = useLazyLoadQuery<useIsTelematikInfrastructureSigningEnabledQuery>(
    isTelematikInfrastructureSigningEnabledQuery,
    {},
  )

  return result.de_isTelematikInfrastructureSigningEnabled
}

export { useIsTelematikInfrastructureSigningEnabled }
